import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Link, Stack, Paper, TextField, Box, Grid, Typography, Card, TableCell, TableContainer,
    Table, InputAdornment, TableHead, Button, IconButton, FormControl, CardContent, DialogContent, DialogTitle, Dialog,
    InputLabel, TableRow, TableBody, Snackbar, CircularProgress, AccordionDetails, MenuItem, Checkbox, Autocomplete, Tooltip, Accordion, AccordionSummary
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import { addPurchaseOrder, editDeletePurchaseOrder, getCNSList, getItemList, getTermsConditionsList, getUnitList, } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import { financialYear } from '../../reusableComponent/financialYear';
import { convertStringIntoTitleCase } from '../../reusableComponent/convertStringIntoTitleCase';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
    // autocompletePaper: {
    //     border: 'none !important',
    //     boxShadow: 'none !important', 
    // },

});

function PurchaseOrderAdd(props) {
    // const editInfo = props.details;
    // const docNoFormateAvailable = props.docNoFormateAvailable;
    const urlLocation = useLocation();
    const prName = urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const backBtnLen = urlLocation.state.backBtn;
    const docNoFormateAvailable = urlLocation.state.docNoFormateAvailable;
    const termsList = urlLocation.state.termsList;
    const unitList = useSelector(state => state.unit.unit)

    const dispatch = useDispatch();
    const classes = useStyles();
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.po_id : null;
    const [isUpdateArray, setIsUpdateArray] = useState(false);
    const currentDate = new Date().toISOString().substring(0, 10);
    const [supplierName, setSupplierName] = useState(editData ? editData.supplierName : prName ? prName : null);

    const supplierList = useSelector(state => state.CNS.CNS)
    const itemList = useSelector(state => state.item.item)
    const availTermsList = editid ? JSON.parse(editData.PO_terms) : [];
    const [rowsTerms, setRowsTerms] = useState([]);

    const [isSet, setIsSet] = useState(false);
    const [purchaseDate, setPurchaseDate] = React.useState(editData ? dayjs(editData.purchaseDate) : dayjs(new Date()));
    const [quotationDate, setQuotationDate] = React.useState(editData ? dayjs(editData.quotationDate) : dayjs(new Date()));

    const [basicTotal, setBasicTotal] = useState(editData ? editData.basicTotal : 0);
    const [gstTotal, setGstTotal] = useState(editData ? editData.gstTotal : 0);
    const [cgstTotal, setCgstTotal] = useState(editData ? editData.cgstTotal : 0);
    const [sgstTotal, setSgstTotal] = useState(editData ? editData.sgstTotal : 0);
    const [igstTotal, setIgstTotal] = useState(editData ? editData.igstTotal : 0);
    const [total, setTotal] = useState(editData ? editData.total : 0);
    const [itemId, setItemId] = useState(null);

    const [data, setData] = useState({
        id: editid,
        orderNo: editData ? editData.orderNo : '',
        quotationNo: editData ? editData.quotationNo : '',
        remark: editData ? editData.remark : '',
    });

    const handleChangeSupplier = (event, newValue) => {
        setSupplierName(newValue)
    }

    const handleChangeTerms = (event, index) => {
        const updatedFields = [...rowsTerms];
        updatedFields[index].trueFalse = event.target.checked;
        setRowsTerms(updatedFields);
        setIsUpdateArray(isUpdateArray ? false : true);
    };


    const [inputFields, setInputFields] = useState(
        editData ? JSON.parse(editData.childRows) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: 0,
                unit: null,
                rate: '',
                gst: '',
                cgst: '',
                sgst: '',
                igst: '',
                gstAmount: '',
                cgstAmount: '',
                sgstAmount: '',
                igstAmount: '',
                basicAmount: '',
                amount: '',
            },
            ]);

    const handleRemoveFields = (ind) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value, i) => i === ind),
            1
        );

        setInputFields(values);
        setIsUpdateArray(isUpdateArray ? false : true);
        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const totalCount = values.length > 0 && values.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
        const gstTotalCount = values.length > 0 && values.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
        const cgstTotalCount = values.length > 0 && values.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
        const sgstTotalCount = values.length > 0 && values.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
        const igstTotalCount = values.length > 0 && values.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);
        const amountTotalCount = values.length > 0 && values.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);

        setBasicTotal(totalCount);
        setGstTotal(gstTotalCount);
        setCgstTotal(cgstTotalCount);
        setSgstTotal(sgstTotalCount);
        setIgstTotal(igstTotalCount);
        setTotal(amountTotalCount);
    };

    const handleChangePurchaseDate = (newValue) => {
        setPurchaseDate(newValue);
    };

    const handleChangeQuotationDate = (newValue) => {
        setQuotationDate(newValue);
    };
    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
        setIsSet(isSet ? false : true)

    }

    const supplierGetData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Supplier' }));
    }
    const itemGetData = () => {
        dispatch(getItemList({ companyId: userInfo.companyId }));
    }



    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const [successMessage, setSuccessMessage] = useState(null);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.purchaseOrder.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Purchase Order already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        // let TermsLength = rowsTerms.filter((n) => n.trueFalse === true)
        // if (TermsLength.length === 0) {
        //     alert("Please select at least one TERMS & CONDITIONS to create purchase order!")
        // } else {
        if (docNoFormateAvailable && docNoFormateAvailable.length === 0) {
            alert("Please enter Document No Format")
        } else {
            let purchaseOrderData = {
                ...data,
                purchaseDate: dateConversionOnEntryPage(purchaseDate),
                quotationDate: dateConversionOnEntryPage(quotationDate),
                childRows: inputFields,
                basicTotal: basicTotal,
                gstTotal: gstTotal,
                cgstTotal: cgstTotal,
                sgstTotal: sgstTotal,
                igstTotal: igstTotal,
                total: total,
                supplierName: supplierName.CSNId,
                companyId: userInfo.companyId,
                rowsTerms: rowsTerms,
                finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, purchaseDate.$M, purchaseDate.$y),
                createdBy: editData ? editData.createdBy : userInfo.userId,
                createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
                modifiedBy: editData ? userInfo.userId : null,
                modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
                changedUpdatedValue: 'edit',
            }

            if (editData) {
                dispatch(editDeletePurchaseOrder(purchaseOrderData));
            } else {
                dispatch(addPurchaseOrder(purchaseOrderData));
            }
        }
        // }
    }

    const unitGetData = () => {
        dispatch(getUnitList({ companyId: userInfo.companyId }));
    }

    useEffect(() => {
        supplierGetData()
        itemGetData()
        unitGetData()

        if (editData) {
            setSupplierName({
                CNS_Name: editData.CNS_Name,
                CSNId: editData.supplierName,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                pinCode: editData.pinCode,
                state: editData.state,
            })

            const newArr = []
            JSON.parse(editData.childRows).map((row) => (
                newArr.push({
                    itemId: row,
                    itemCode: row.itemCode,
                    // itemId: row.itemId,
                    itemName: row.itemName,
                    hsnCode: row.hsnCode,
                    quantity: row.quantity,
                    unit: row,
                    rate: row.rate,
                    gst: row.gst,
                    cgst: row.cgst,
                    sgst: row.sgst,
                    igst: row.igst,
                    gstAmount: row.gstAmount,
                    cgstAmount: row.cgstAmount,
                    sgstAmount: row.sgstAmount,
                    igstAmount: row.igstAmount,
                    basicAmount: row.basicAmount,
                    amount: row.amount,
                })
            ))

            setInputFields(newArr)
        }

    }, []);

    useEffect(() => {

    }, [termsList, availTermsList])

    const handleChangeUnit = (index) => (event, newValue) => {
        setInputFields((prevInputFields) => {
            const updatedFields = [...prevInputFields];
            updatedFields[index].unit = newValue;
            return updatedFields;
        })
    }

    useEffect(() => {
        const initialInputFields = termsList && termsList.map((r, index) => ({
            id: uuidv4(),
            termsAndConditions: r.termsAndConditions,
            trueFalse: editid === null ? true : availTermsList.find((n) => n.termsAndConditions === r.termsAndConditions).trueFalse,
        }));
        setRowsTerms(initialInputFields);
    }, [])

    const handleCalculation = (rate, qty, gst) => {
        const basicAmt = parseFloat(rate) * parseFloat(qty);
        const gstAmt = (basicAmt * parseFloat(gst)) / 100;
        const totalAmt = basicAmt + gstAmt;
        const cgstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (basicAmt * parseFloat(cgstPer)) / 100;
        const sgstAmt = (basicAmt * parseFloat(sgstPer)) / 100;
        const igstAmt = (basicAmt * parseFloat(igstPer)) / 100;


        return {
            rate: parseFloat(rate),
            quantity: parseFloat(qty),
            gst: parseFloat(gst),
            basicAmount: basicAmt,
            gstAmount: gstAmt,
            amount: totalAmt,
            cgst: cgstPer,
            sgst: sgstPer,
            igst: igstPer,
            cgstAmount: cgstAmt,
            sgstAmount: sgstAmt,
            igstAmount: igstAmt,
        };
    }

    const handleChangeItemDescription = (index) => (event, newValue) => {

        const updatedInputFields = inputFields.map((row, ind) => {

            if (ind === index) {
                const calculatedValues = handleCalculation(
                    newValue?.rate || 0,
                    parseFloat(row.quantity),
                    newValue?.gst || 0
                );

                return {
                    ...row,
                    itemId: newValue,
                    itemDescription: newValue ? newValue.itemDescription : null,
                    itemCode: newValue ? newValue.itemCode : null,
                    itemName: newValue ? newValue.itemName : null,
                    hsnCode: newValue ? newValue.hsnCode : null,
                    ...calculatedValues,
                    unit: newValue === null ? null : newValue,
                };
            }
            return row;
        });

        setInputFields(updatedInputFields);
        setIsUpdateArray(!isUpdateArray);

        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const totalCount = updatedInputFields.map(value => value.basicAmount).reduce(reducer, 0);
        const gstTotalCount = updatedInputFields.map(value => value.gstAmount).reduce(reducer, 0);
        const cgstTotalCount = updatedInputFields.map(value => value.cgstAmount).reduce(reducer, 0);
        const sgstTotalCount = updatedInputFields.map(value => value.sgstAmount).reduce(reducer, 0);
        const igstTotalCount = updatedInputFields.map(value => value.igstAmount).reduce(reducer, 0);
        const amountTotalCount = updatedInputFields.map(value => value.amount).reduce(reducer, 0);

        setBasicTotal(totalCount);
        setGstTotal(gstTotalCount);
        setCgstTotal(cgstTotalCount);
        setSgstTotal(sgstTotalCount);
        setIgstTotal(igstTotalCount);
        setTotal(amountTotalCount);
    };


    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = array[i];

        result[e.target.name] = e.target.value;
        array[i] = result;

        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);

        let tltAmt = result['amount'] ? result['amount'] : 0;
        let qty = result['quantity'] ? result['quantity'] : 0;
        let rate = result['rate'] ? result['rate'] : 0;
        let gst = result['gst'] ? result['gst'] : 0;

        if (e.target.name == 'quantity') {
            qty = parseFloat(e.target.value);
            handleCalculation(
                result['rate'],
                e.target.value,
                result['gst']
            );
        }

        if (e.target.name == 'rate') {
            rate = parseFloat(e.target.value);
            handleCalculation(
                e.target.value,
                result['quantity'],
                result['gst']
            );
        }

        if (e.target.name == 'gst') {
            gst = parseFloat(e.target.value);
            handleCalculation(
                result['rate'],
                result['quantity'],
                e.target.value,
            );
        }
        let basicAmt = parseFloat(qty) * parseFloat(rate);
        let gstAmt = (parseFloat(basicAmt) * parseFloat(gst)) / 100;

        tltAmt = parseFloat(basicAmt) + parseFloat(gstAmt);
        result['basicAmount'] = parseFloat(basicAmt);
        result['gstAmount'] = parseFloat(gstAmt);
        result['amount'] = parseFloat(tltAmt);

        const cgstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (convertStringIntoTitleCase(supplierName.state) === convertStringIntoTitleCase(userInfo.state)) ? 0 : (parseFloat(gst));

        const cgstAmt = (basicAmt * parseFloat(cgstPer)) / 100;
        const sgstAmt = (basicAmt * parseFloat(sgstPer)) / 100;
        const igstAmt = (basicAmt * parseFloat(igstPer)) / 100;

        result['cgstAmount'] = parseFloat(cgstAmt);
        result['sgstAmount'] = parseFloat(sgstAmt);
        result['igstAmount'] = parseFloat(igstAmt);


        array[i] = result;

        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const totalCount = inputFields && inputFields.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
        setBasicTotal(totalCount);

        const gstTotalCount = inputFields && inputFields.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
        const amountTotalCount = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);

        setGstTotal(gstTotalCount);
        setTotal(amountTotalCount);

        const cgstTotalCount = inputFields && inputFields.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
        const sgstTotalCount = inputFields && inputFields.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
        const igstTotalCount = inputFields && inputFields.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);

        setCgstTotal(cgstTotalCount);
        setSgstTotal(sgstTotalCount);
        setIgstTotal(igstTotalCount);

    };

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                itemCode: '',
                itemName: '',
                itemId: null,
                hsnCode: '',
                rate: '',
                quantity: 0,
                unit: null,
                gst: 0,
                amount: '',
                basicAmount: '',
                gstAmount: '',
            },
        ]);
    };

    const navigate = useNavigate();

    const navigateToAddEdit = (row) => {
        const state = {
            CNS_Type: 'Supplier',
            availCNS_Type: true,
        };
        navigate('/masters/add-party-masters', { state });
    };

    const lastEntryNo = useSelector(state => state.purchaseOrder.lastEntryNo)

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Purchase', path: '/purchase/' },
                        { name: 'Purchase Order List', path: '/purchase/purchase-order' },
                        { name: 'Create Purchase Order' },
                    ]}
                />
                <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>

                    {/* <Box>
                        <Grid container spacing={0.2} sx={{ pb: 1 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create Purchase Order</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                    <Box sx={{ m: 2 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={0} sx={{ p: 0 }}>
                                <Grid item md={6}>
                                    <Box sx={{ display: 'flex' }}>
                                        <Autocomplete sx={{ marginBottom: '10px' }}

                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={supplierList}
                                            value={supplierName}
                                            onChange={handleChangeSupplier}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Please Select Supplier"
                                                sx={{
                                                    width: { sm: 400, md: 400 },
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12,
                                                    }
                                                }} {...params} />}
                                        />
                                        <AddCircleOutlineOutlinedIcon className={`${styles.addBtnEntry}`} onClick={() => navigateToAddEdit()} />
                                    </Box>
                                    {supplierName &&
                                        <Card sx={{ maxWidth: 400, backgroundColor: '#f0efed', }}>
                                            <CardContent sx={{ padding: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }}> {supplierName.CNS_Name}</Typography>
                                                {/* <Typography sx={{ fontSize: '11px', }}><Icon icon="arcticons:gstrings" width="14" height="12" style={{ marginRight: '7px' }} /> {supplierName.gstn} </Typography> */}
                                                <Typography sx={{ fontSize: '11px' }}> <Icon icon="fa6-regular:address-card" width="12" height="12" style={{ marginRight: '8px' }} /> {supplierName.address}</Typography>
                                                <Typography sx={{ fontSize: '11px' }}> {supplierName.state + ","} {supplierName.pinCode} </Typography>
                                            </CardContent>
                                        </Card>
                                    }
                                </Grid>
                                <Grid item md={6}>
                                    <Box >
                                        <Grid container spacing={1} >
                                        {!editData &&
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`} sx={{ fontWeight: 'bold', color: '#0000cc' }}> Last PO No</Typography>
                                                    </Grid>
                                                    <Grid item xs={10}>
                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#0000cc' }} >{lastEntryNo}</Typography>
                                                    </Grid>
                                                </>
                                            }
                                            {editData ?
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>PO No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            disabled={true}
                                                            size='small'
                                                            fullWidth
                                                            name="purchaseNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={editData.purchaseNo}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>PO No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={`${styles.skeleton_text}`}>
                                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}> </Typography>
                                                        </div>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}> PO. Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="purchaseDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={purchaseDate}
                                                        onChange={handleChangePurchaseDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Quotation No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="quotationNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.quotationNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Quotation Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="quotationDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={quotationDate}
                                                        onChange={handleChangeQuotationDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <br />
                        <Box>
                            <IconButton style={{ color: 'blue', fontSize: '28px', float: 'right' }} onClick={handleAddFields}>
                                <Icon icon="mdi:plus-box-outline" />
                            </IconButton>
                        </Box>
                        <TableContainer sx={{ overflowY: 'auto', minHeight: 140, maxHeight: 170 }}>
                            <Table sx={{ minWidth: 700, }} size='small' stickyHeader>
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} width="50%">
                                            Item Description
                                        </StyledTableCell >
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>HSN Code</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Rate</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Quantity</StyledTableCell >
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>Unit</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>GST %</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Amount</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell >
                                    </StyledTableRow>
                                </TableHead >
                                <TableBody>
                                {inputFields.length > 0 && Array.isArray(inputFields) && inputFields.map((row, index) => (
                                    <>
                                        {supplierName &&
                                        <StyledTableRow key={row.itemId} >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                <Autocomplete

                                                    fullWidth
                                                    classes={{
                                                        option: classes.option,
                                                        // paper: classes.autocompletePaper,
                                                    }}
                                                    noOptionsText={
                                                        <span className={classes.noOptionsLabel}>No options</span>
                                                    }
                                                    options={itemList}
                                                    value={row.itemId}
                                                    onChange={handleChangeItemDescription(index)}
                                                    getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                    getOptionSelected={(option, value) => option.id === value.id}
                                                    renderInput={(params) => <ERPinput required variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        {...params} />}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                <ERPinput
                                                    variant="standard"
                                                    required
                                                    type="text"
                                                    name="hsnCode"
                                                    value={row.hsnCode}
                                                    size='small'
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}

                                                />
                                            </StyledTableCell>
                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="rate"
                                                    value={row.rate}
                                                    size='small'
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>

                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="quantity"
                                                    value={row.quantity}
                                                    size='small'
                                                    // onChange={(e) => handleChangeTable(e, index)}
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <Autocomplete
                                                            fullWidth
                                                            classes={{
                                                                option: classes.option,
                                                            }}
                                                            noOptionsText={
                                                                <span className={classes.noOptionsLabel}>No options</span>
                                                            }
                                                            options={unitList}
                                                            value={row.unit}
                                                            onChange={handleChangeUnit(index)}
                                                            getOptionLabel={(option) => option.unit}
                                                            getOptionSelected={(option, value) => option.unit === value.unit}
                                                            renderInput={(params) => <ERPinput required variant="standard"
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                {...params} />}
                                                        />
                                            </StyledTableCell>
                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="gst"
                                                    value={row.gst}
                                                    size='small'
                                                    // onChange={(e) => handleChangeTable(e, index)}
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="amount"
                                                    value={parseFloat(row.amount).toFixed(2)}
                                                    size='small'
                                                    // onChange={(e) => handleChangeTable(e, index)}
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        readOnly: true,
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`} >
                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                    {/* <IconButton size="small" style={{ color: 'blue', fontSize: '14px' }} onClick={handleAddFields}>
                                                        <Icon icon="line-md:plus" />
                                                    </IconButton> */}
                                                    {/* {index === 0 ?
                                                        <IconButton disabled size="small" sx={{ fontSize: '12px', color: 'red' }} >
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton> : */}
                                                        <IconButton size="small" onClick={() => handleRemoveFields(index)} sx={{ fontSize: '12px', color: 'red' }}>
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton>
                                                        {/* } */}
                                                </Box>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        }
                                    </>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box >
                            <Grid container spacing={0} sx={{ mt: 1, }}>
                                <Grid item xs={8}>
                                    <Grid item xs={12} md={12} >
                                        <Typography className={`${styles.erp_lable}`} sx={{ marginBottom: '8px' }}> Remarks</Typography>
                                        <ERPinput
                                            sx={{
                                                width: { sm: 100, md: 400 },
                                                "& .MuiInputBase-root": {
                                                    height: 25,
                                                    fontSize: 12
                                                }
                                            }}
                                            fullWidth
                                            type="text"
                                            name="remark"
                                            size='small'
                                            onChange={handleChange}
                                            value={(data.remark)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12} >
                                        <Accordion style={{ boxShadow: 'none' }} defaultExpanded={editid}>
                                            <AccordionSummary style={{ padding: '0px', maxWidth: '120px' }}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography sx={{ color: 'blue', fontSize: '12px', textDecoration: 'underline', padding: 'none' }}>Terms & conditions </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: '0px' }} className={`${styles.custom_scrollbar}`}>
                                                <Box className={`${styles.custom_scrollbar_content}`}>
                                                    {rowsTerms && rowsTerms.map((row, index) => {
                                                        return (
                                                            <Grid container spacing={0} sx={{ mt: 0 }}>
                                                                <Grid item xs={12}>
                                                                    <Box style={{ display: 'flex' }}>
                                                                        <Checkbox
                                                                            sx={{ transform: 'scale(0.75)', height: '2px', padding: '9px 4px 5px 1px' }}
                                                                            size="small"
                                                                            name="trueFalse"
                                                                            value={row.trueFalse}
                                                                            defaultChecked={row.trueFalse}
                                                                            onChange={(event) => handleChangeTerms(event, index)}
                                                                        />

                                                                        <Typography className={`${styles.erp_lable}`} style={{ paddingRight: '10px', }}>{index + 1}. </Typography>
                                                                        <Typography className={`${styles.erp_lable}`} style={{ paddingBottom: '4px' }}>  {row.termsAndConditions}</Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4} >
                                    <Grid container spacing={0} sx={{ mt: 1.5, }} >
                                        <Grid item xs={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>Basic Amount </Typography>
                                        </Grid>
                                        <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="basicTotal"
                                                onChange={handleChange}
                                                value={parseFloat(basicTotal).toFixed(2)}
                                                size='small'
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography className={`${styles.erp_lable}`}>GST Amount </Typography>
                                        </Grid>
                                        <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <ERPinputNo
                                                variant="standard"
                                                required
                                                type="number"
                                                name="gstTotal"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(gstTotal).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={7} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                            <Typography sx={{ textAlign: 'right', fontSize: '22px', fontWeight: 'bold' }}> Total Amount</Typography>
                                        </Grid>
                                        <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #c0c0c0', borderTop: '1px solid #c0c0c0' }}>
                                            <ERPinputNo
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: 38,
                                                        "& input": {
                                                            textAlign: "right",
                                                            fontSize: '22px',
                                                            fontWeight: 'bold',
                                                            color: '#000000'
                                                        }
                                                    }
                                                }}
                                                variant="standard"
                                                type="number"
                                                name="total"
                                                size='small'
                                                onChange={handleChange}
                                                value={parseFloat(total).toFixed(2)}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                </Button>
                                <Cancel />
                            </Box>
                        </Box>
                    </form>
                </Paper>
            </div>
            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
        </>
    )
}


export default PurchaseOrderAdd